import 'dropify/dist/css/dropify.min.css';
import 'dropify/dist/js/dropify.min.js';
import $ from 'jquery';

// Set up Dropify initialization
export function initDropify() {
    $('.dropify').dropify();
}

// ✅ Optional: make globally accessible (for external re-inits)
window.initDropify = initDropify;

// ✅ Ensure jQuery is global and dropify plugin is exposed
window.$ = $;
window.jQuery = $;
window.dropify = $.fn.dropify;  // ⬅️ This makes window.dropify() usable
